import { ProductfinderData } from "../views/productfinder/productfinder-data";
import { ProductfinderResult } from "../views/productfinder/productfinder-result";
import { ProductfinderCustomerData } from "../views/productfinder/productfinder-offer-data";
import { ProductfinderDownloadData } from "../views/productfinder/productfinder-downloads-data";

export class ApplicationState {
  loggedInUser: string;
  isNodeDebuggingEnvironment: boolean = (<any>window)
    .isNodeDebuggingEnvironment;

  get productfinderData(): ProductfinderData {
    return new ProductfinderData(this.load("productfinderData"));
  }

  set productfinderData(value: ProductfinderData) {
    this.store("productfinderData", value);
  }

  get productfinderDownloadData(): ProductfinderDownloadData {
    return new ProductfinderDownloadData(
      this.load("productfinderDownloadData"),
    );
  }

  set productfinderDownloadData(value: ProductfinderDownloadData) {
    this.store("productfinderDownloadData", value);
  }

  get productfinderResult(): ProductfinderResult {
    return this.load("productfinderResult");
  }

  set productfinderResult(value: ProductfinderResult) {
    this.store("productfinderResult", value);
  }

  get productfinderCustomerData(): ProductfinderCustomerData {
    return new ProductfinderCustomerData(
      this.load("productfinderCustomerData"),
    );
  }

  set productfinderCustomerData(value: ProductfinderCustomerData) {
    this.store("productfinderCustomerData", value);
  }

  private store(key: string, value: any): void {
    let str = JSON.stringify(value);
    window.sessionStorage && window.sessionStorage.setItem(key, str);
  }

  private load(key: string): any {
    let str = window.sessionStorage && window.sessionStorage.getItem(key);
    return str && JSON.parse(str);
  }
}
